<template>
  <div>
    <el-input :placeholder="[showEditTag ? '请输入标签名称' : '添加标签']" @focus="showEditTag = true" v-model="newtag.name">
      <i slot="prefix" class="el-input__icon" :class="[ showEditTag ? 'el-icon-close' : 'el-icon-plus' ]" @click="showEditTag = !showEditTag"></i>
      <i slot="suffix" class="el-input__icon" :class="[ showEditTag ? 'el-icon-check' : '' ]"  @click="saveTag"></i>
    </el-input>
    <div style="height: 200px; overflow:auto"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="disabled"
         :infinite-scroll-immediate="false">
<!--      <el-scrollbar style="height: 200px;" class="default-scrollbar content-bg" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">-->
        <el-checkbox-group v-model="checkTags" size="small" @change="tagChange">
          <div style="margin: 15px 0; font-size: 18px"
               v-for="(tag, index) of tags"
               :key="index">
            <el-checkbox :label="tag.name" :key="index"></el-checkbox>
            <i style="float: right; padding-right: 10px; line-height: 21px" class="el-icon-delete" @click="deleteTag(tag)"></i>
          </div>
        </el-checkbox-group>
        <p v-if="loading" style="text-align: center">加载中...</p>
<!--        <p v-else-if="tags.length === 0" style="text-align: center">还没有标签 请点击添加一个</p>-->
        <p v-if="tags.length >= total && tags.length !== 0" style="text-align: center">没有更多了</p>
        <div v-else style="text-align: center; padding-top: 50px">没有标签, 请先添加标签</div>
<!--      </el-scrollbar>-->
    </div>
  </div>
</template>

<script>
import RecordTagsService from '@/request/record/recordTag'
// import _ from 'lodash'
export default {
  name: "RecordTag",
  props: {
    oid: [Number, String],
    recordTags: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      showEditTag: false,
      tagsPageParams: { oids: null, pageSize: 5, pageOffset: 1, total: 0 },
      newtag: { name: null, id: null, odi: null },
      tags: [],
      checkTags: [],
      loading: false,
      total: 20
    }
  },
  computed: {
    disabled () {
      return this.loading || this.tags.length >= this.total
    }
  },
  watch: {
    oid () {
      this.newtag.oid = this.oid
      this.loadData()
    },
    recordTags: {
      deep: true,
      handler () {
        if (this.checkTags.toString() !== this.recordTags.toString()) {
          this.checkTags = this.recordTags
        }
      }
    }
  },
  created () {
    this.newtag.oid = this.oid
    this.checkTags = this.recordTags
    this.loadData()
  },
  methods: {
    loadData () {
      if (this.oid) {
        this.tagsPageParams.pageSize = 5
        this.tagsPageParams.oids = this.oid
        RecordTagsService.findTag(this.tagsPageParams).then(res => {
          if (res.result) {
            this.total = res.result.totalElements
            this.tags = res.result.content || []
          }
        })
      }
    },
    loadMore () {
      this.loading = true
      this.tagsPageParams.pageSize += 5
      RecordTagsService.findTag(this.tagsPageParams).then(res => {
        if (res.result) {
          this.tags = res.result.content || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    tagChange (checkTags) {
      this.$emit('tagChange', checkTags)
    },
    saveTag () {
      if (!this.newtag.name || this.newtag.name === '') {
        this.$message.error('标签内容不能为空')
        return
      }
      RecordTagsService.save({name: this.newtag.name, oid: this.oid}).then((res) => {
        if (res.result) {
          this.$message.success('创建成功')
          this.loadData()
        }
      }).finally(() => {
        this.newtag = { name: null, id: null, odi: null }
        this.showEditTag = false
      })
    },
    deleteTag (tag) {
      this.$confirm('删除后不可撤销, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (tag.id) {
          RecordTagsService.delete(tag).then(res => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              const i = this.checkTags.indexOf(tag.name)
              if(i >= 0) {
                this.checkTags.splice(i, 1)
                this.$emit('tagChange', this.checkTags)
              }
              this.tags.splice(this.tags.indexOf(tag), 1)
              this.total -= 1
            }
          }).catch((res) => {
            this.$message.error(res.message || '不能删除已被使用的标签')
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
